import { Data2, newId } from '../../data-types'
import { O } from '../../ui'
import { Address } from '../types'

export const useAddressBuilders = () => {
    const buildAddress = (data: Data2) => {
        const { id = newId(), betweenStreets, locality, province, archived } = data
        const address: Address = {
            id: id! as string,
            address: data.address! as string,
            betweenStreets: betweenStreets as O<string>,
            locality: locality! as string,
            province: province! as string,
            archived: !!archived
        }

        return address
    }

    return {
        buildAddress
    }
}
